"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _socket = require("socket.io-client");

var _core = _interopRequireDefault(require("./core"));

var _request2 = _interopRequireWildcard(require("./request"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var WS = /*#__PURE__*/function () {
  function WS() {
    _classCallCheck(this, WS);
  }

  _createClass(WS, null, [{
    key: "install",
    value: function install(Vue) {
      Vue.prototype.$ws = this;
    }
  }, {
    key: "initConnection",
    value: function initConnection() {
      var _this = this;

      if (this.socket) {
        return;
      }

      this.socket = (0, _socket.io)(this.uri, _objectSpread({
        transports: this.options.transports || ['websocket']
      }, this.options));
      this.socket.on('message', this.data); // Connection events

      this.socket.on('connect', function () {
        return _this.handleState(true, 'connect');
      });
      this.socket.on('reconnect', function () {
        return _this.handleState(true, 'reconnect');
      });
      this.socket.on('disconnect', function () {
        return _this.handleState(false, 'disconnect');
      });
    }
  }, {
    key: "handleState",
    value: function () {
      var _handleState = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(online) {
        var event,
            _args = arguments;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                event = _args.length > 1 && _args[1] !== undefined ? _args[1] : null;

                if (this.online !== online) {
                  _core["default"].eventhub.emit("core:ws:".concat(this.uri, ":state"), online, this.online); // Set online state


                  this.online = online;
                }

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function handleState(_x) {
        return _handleState.apply(this, arguments);
      }

      return handleState;
    }()
  }, {
    key: "on",
    value: function on() {
      var _this$socket;

      var event = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      this.initConnection();

      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      return (_this$socket = this.socket).on.apply(_this$socket, [event].concat(args));
    }
  }, {
    key: "off",
    value: function off() {
      var _this$socket2;

      var event = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        args[_key2 - 1] = arguments[_key2];
      }

      return (_this$socket2 = this.socket).off.apply(_this$socket2, [event].concat(args));
    }
  }, {
    key: "data",
    value: function () {
      var _data = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var message,
            _args2 = arguments;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                message = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : {};
                console.log('received message:', message);

              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function data() {
        return _data.apply(this, arguments);
      }

      return data;
    }()
  }, {
    key: "refreshTokenset",
    value: function () {
      var _refreshTokenset = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var _this2 = this;

        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (!this.refreshTokensetPromise) {
                  _context4.next = 2;
                  break;
                }

                return _context4.abrupt("return", this.refreshTokensetPromise);

              case 2:
                // If it wasn't set yet, set it now
                this.refreshTokensetPromise = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
                  var response;
                  return regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                      switch (_context3.prev = _context3.next) {
                        case 0:
                          _context3.prev = 0;
                          _context3.next = 3;
                          return _this2.post('/auth/refreshtoken', {
                            body: {
                              refreshtoken: _core["default"].auth.refreshtoken
                            }
                          }, {
                            refreshtoken: true,
                            skipAuth: true
                          });

                        case 3:
                          response = _context3.sent;

                          _core["default"].auth.saveCredentials(response);

                        case 5:
                          _context3.prev = 5;
                          _this2.refreshTokensetPromise = null;
                          return _context3.finish(5);

                        case 8:
                        case "end":
                          return _context3.stop();
                      }
                    }
                  }, _callee3, null, [[0,, 5, 8]]);
                }))();
                return _context4.abrupt("return", this.refreshTokensetPromise);

              case 4:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function refreshTokenset() {
        return _refreshTokenset.apply(this, arguments);
      }

      return refreshTokenset;
    }()
  }, {
    key: "request",
    value: function () {
      var _request = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(method, url) {
        var _this3 = this;

        var data,
            options,
            _args6 = arguments;
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                data = _args6.length > 2 && _args6[2] !== undefined ? _args6[2] : {};
                options = _args6.length > 3 && _args6[3] !== undefined ? _args6[3] : {};
                this.initConnection();

                if (!(options.refreshtoken !== true && _core["default"].auth.shouldRefreshToken() === true)) {
                  _context6.next = 6;
                  break;
                }

                _context6.next = 6;
                return this.refreshTokenset();

              case 6:
                if (!data.body) data.body = {};
                if (!data.headers) data.headers = {};
                if (!data.query) data.query = {};
                data.headers = _objectSpread(_objectSpread({}, data.headers), _request2["default"].defaultHeaders(_objectSpread({}, options))); // beforeRequest hooks

                _context6.next = 12;
                return _request2["default"].__beforeRequest(method, url, data, options);

              case 12:
                return _context6.abrupt("return", new Promise(function (resolve, reject) {
                  _this3.socket.emit('request', {
                    method: method,
                    url: url,
                    body: data.body,
                    query: data.query,
                    headers: data.headers
                  }, /*#__PURE__*/function () {
                    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(response) {
                      return regeneratorRuntime.wrap(function _callee5$(_context5) {
                        while (1) {
                          switch (_context5.prev = _context5.next) {
                            case 0:
                              if (!(!response || !(response.code >= 200 && response.code < 300))) {
                                _context5.next = 15;
                                break;
                              }

                              if (!(response && response.data && response.data.error === 'Unauthorized')) {
                                _context5.next = 14;
                                break;
                              }

                              if (!(_core["default"].auth.refreshtoken && options.skipAuth !== true)) {
                                _context5.next = 13;
                                break;
                              }

                              _context5.prev = 3;
                              _context5.next = 6;
                              return _this3.refreshTokenset();

                            case 6:
                              _context5.next = 12;
                              break;

                            case 8:
                              _context5.prev = 8;
                              _context5.t0 = _context5["catch"](3);

                              // If 404, logout because refreshtoken is not found
                              if (_context5.t0.code === 404) {
                                _core["default"].auth.logout();
                              }

                              return _context5.abrupt("return", reject(_context5.t0));

                            case 12:
                              return _context5.abrupt("return", resolve(_this3.request(method, url, data, options)));

                            case 13:
                              // If no refreshtoken is found, just log out
                              _core["default"].auth.logout();

                            case 14:
                              return _context5.abrupt("return", reject(new _request2.RequestError('ApiError', {
                                code: response.data.code,
                                error: response.data.error,
                                message: response.data.message,
                                transport: 'ws',
                                response: response.data
                              })));

                            case 15:
                              return _context5.abrupt("return", resolve(response.data));

                            case 16:
                            case "end":
                              return _context5.stop();
                          }
                        }
                      }, _callee5, null, [[3, 8]]);
                    }));

                    return function (_x4) {
                      return _ref2.apply(this, arguments);
                    };
                  }());
                }));

              case 13:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function request(_x2, _x3) {
        return _request.apply(this, arguments);
      }

      return request;
    }()
  }, {
    key: "get",
    value: function get() {
      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }

      return this.request.apply(this, ['get'].concat(args));
    }
  }, {
    key: "post",
    value: function post() {
      for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        args[_key4] = arguments[_key4];
      }

      return this.request.apply(this, ['post'].concat(args));
    }
  }, {
    key: "put",
    value: function put() {
      for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
        args[_key5] = arguments[_key5];
      }

      return this.request.apply(this, ['put'].concat(args));
    }
  }, {
    key: "patch",
    value: function patch() {
      for (var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
        args[_key6] = arguments[_key6];
      }

      return this.request.apply(this, ['patch'].concat(args));
    }
  }, {
    key: "delete",
    value: function _delete() {
      for (var _len7 = arguments.length, args = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
        args[_key7] = arguments[_key7];
      }

      return this.request.apply(this, ['delete'].concat(args));
    }
  }]);

  return WS;
}();

exports["default"] = WS;
WS.uri = 'http://localhost:3000';
WS.options = {};
WS.refreshTokensetPromise = null;
WS.online = null;